export default __webpack_public_path__ + "static/media/oavelEN.8238fe0f.md";